export default __webpack_public_path__ + "static/media/cz6.b9c12731.svg";